export default {
  head: {
    aboutus: "<p>银川建设采购服务平台</p>",
    citycode: "640000",
    guid: "AEE20DFD3BC94C2D8CB7FCF173D88137",
    icp: "宁ICP备07500099号-1",
    gwIcp: "宁公网安备64010602001060",
    logofileguid: "",
    logourl: "/imgs/logo.png",
    meta: "银川建设采购服务平台",
    planname: "ycjs",
    tel: "400-630-6886",
    email: "nxhuizezhao@163.com",
    title: "银川建设采购服务平台",
    address:
      "宁夏回族自治区银川市兴庆区文化东街241号永康巷与文化东街交叉路口东北角",
    companyname: "银川有形建设工程服务中心（有限公司）",
  },
  personlist: [
    {
      imgsrc: "/img/hzzlogin/tb.png",
      href: "http://tb.ycjs.com.cn/#/login?plan=ycjs",
      con: "投标人登录",
    },
    {
      imgsrc: "/img/hzzlogin/zb.png",
      href: "http://dl.ycjs.com.cn/otc/#/login?plan=ycjs&mRole=agent",
      con: "招标代理登录",
    },
    {
      imgsrc: "/img/hzzlogin/cg.png",
      href: "http://dl.ycjs.com.cn/otc/#/login?plan=ycjs&mRole=tender",
      con: "招标人登录",
    },
    {
      imgsrc: "/img/hzzlogin/pb.png",
      href: "http://pb.ycjs.com.cn",
      con: "评标登录",
    },
  ],
  urlList: [
    {
      address: "https://ggzyjy.fzggw.nx.gov.cn/",
      text: "宁夏回族自治区公共资源交易中心网站",
    },
    {
      address:
        "http://www.ccgp-ningxia.gov.cn/public/NXGPPNEW/dynamic/index.jsp?id=1",
      text: "宁夏回族自治区政府采购网",
    },
    {
      address: "https://www.nx.gov.cn/",
      text: "宁夏回族自治区人民政府网站",
    },
    {
      address: "http://www.cebpubservice.com/",
      text: "中国招投标公共服务平台",
    },
  ],
};
